export class BaseUtil {

  static removeFromStatus(dataList: { code: string, description: string }[], elToRemove :string [] = ['']) {
    return dataList.filter(el => !elToRemove.includes(el.code))
  }

  static removeFromStatusExcept(dataList: { code: string, description: string }[], elToKeep :string [] = ['']) {
    return dataList.filter(el => elToKeep.includes(el.code))
  }

}
